module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_f_albino.2f662243.png";